import { useEffect, useMemo } from "react";
export default (function () {
    var el = useMemo(function () { return document.createElement("div"); }, []);
    useEffect(function () {
        document.body.append(el);
        return function () { return document.body.removeChild(el); };
    }, []);
    return el;
});
